import React from 'react';
import { Global } from '@emotion/react';
import { oneOfType, arrayOf, node } from 'prop-types';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { globalStyles } from './global.styles';
import { Colors, Elevations, Fonts } from '../Foundation';
import { hyperlinkStyle } from '../Atoms';
import { ActivityColorPalette } from './colorPalette';
export const customMuiTheme = createTheme({
  palette: {
    text: {
      primary: Colors.charcoal,
      secondary: Colors.new_grey,
      disabled: Colors.new_grey_light
    },
    primary: {
      main: Colors.plum_paddl,
      dark: Colors.plum_dark
    },
    secondary: {
      main: Colors.plum_electric,
      light: Colors.plum_dark_active
    },
    backgroundColors: {
      light: 'white',
      dark: Colors.grey_magnolia
    },
    education: {
      main: ActivityColorPalette.education
    },
    employment: {
      main: ActivityColorPalette.employment
    },
    life: {
      main: ActivityColorPalette.life
    },
    personal: {
      main: ActivityColorPalette.personal
    },
    competition: {
      main: ActivityColorPalette.competition
    },
    social: {
      main: ActivityColorPalette.social
    }
  },
  typography: {
    fontFamily: ['Gordita', 'sofia-pro', 'Helvetica', 'Roboto', 'Arial', 'sans-serif'].join(',')
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: "\n          ".concat(Fonts.buttonText, "\n          padding: 12px 32px;\n          text-transform: none;\n        "),
        text: "\n          text-transform: none;\n          text-decoration-line: underline;\n          padding: 2px 4px;\n          color: ".concat(Colors.new_grey_light, ";\n          :hover, :active {\n            background-color: transparent;\n            text-decoration-line: underline;\n            color: ").concat(Colors.plum_electric_active, ";\n          }\n        ")
      }
    },
    MuiChip: {
      styleOverrides: {
        root: "\n          height: 40px;\n          padding: 8px 16px;\n          background: white;\n          box-shadow: ".concat(Elevations.elevation, ";\n          border-radius: 32px;\n        "),
        label: "".concat(Fonts.labelTextBold)
      }
    },
    MuiLink: {
      styleOverrides: {
        root: hyperlinkStyle
      }
    },
    MuiTab: {
      styleOverrides: {
        root: "\n        ".concat(Fonts.H3, "\n        text-transform: none;\n        height: 64px;\n        &:hover {\n          color: ").concat(Colors.charcoal, ";\n        }\n        &.Mui-selected {\n          color: ").concat(Colors.charcoal, ";\n          border-bottom: 4px solid ").concat(Colors.plum_electric_active, ";\n        ")
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: "\n          justify-content: space-between;\n          padding: 32px 0 24px;\n          min-height: unset;\n\n          @media (min-width: 600px){\n            min-height: unset;\n            padding: 32px 0 24px;\n          }\n        "
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: "\n          ".concat(Fonts.labelText, ";\n          color: ").concat(Colors.new_grey_dark, ";\n          border-bottom: none;\n        "),
        head: "\n          ".concat(Fonts.labelTextMedium, ";\n          color: ").concat(Colors.charcoal, ";\n        ")
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: "\n          padding: 32px 0;\n        "
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: "\n         .MuiFormControlLabel-label {\n          ".concat(Fonts.labelTextMedium, "\n        }")
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: "\n         .MuiSwitch-thumb {\n          background-color: white;\n        }"
      }
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: "\n        \n        .MuiToggleButtonGroup-grouped:not(:first-of-type) {\n          border-left: 1px solid ".concat(Colors.grey_magnolia, ";\n\n          &.Mui-selected, :hover {\n            border-left: 1px solid transparent;\n          }\n        }\n        ")
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: "\n        background-color: white;\n        margin-left: 0;\n        ".concat(Fonts.labelTextBold, ";\n        color: ").concat(Colors.new_grey, ";\n\n        :hover {\n          background-color: ").concat(Colors.grey_lighter, ";\n        }\n\n        &.Mui-selected {\n          color: white;\n          background-color: ").concat(Colors.plum_electric_active, ";\n\n          :hover {\n            background-color: ").concat(Colors.plum_electric_active, ";\n          }\n        }\n        ")
      }
    }
  }
});
export const BaselineStylesProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: customMuiTheme
  }, /*#__PURE__*/React.createElement(Global, {
    styles: globalStyles
  }), children);
};
BaselineStylesProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired
};